import { useObservable } from "../../../../../libs/react";
import { ILicenseContext } from "../../../../../services/licenses/Interfaces";
import { useCustomerContext } from "../../UseCustomer";

export function useLicenseContext() : ILicenseContext | undefined
{
    const customerContext = useCustomerContext();
    return useObservable(customerContext?.licenses.obsSelectedLicenseContext);
}
